import React from 'react';
import { Link } from 'react-router-dom';
var MultiLink = function (_a) {
    var children = _a.children, href = _a.href, type = _a.type, onClick = _a.onClick, id = _a.id, role = _a.role, target = _a.target, rel = _a.rel, className = _a.className, itemProp = _a.itemProp, title = _a.title;
    if (!type) {
        type = 'to';
    }
    if (type === 'to') {
        return (React.createElement(Link, { to: href, id: id, target: target, rel: rel, itemProp: itemProp, onClick: onClick, className: className, title: title }, children));
    }
    else {
        return (React.createElement("a", { href: href, id: id, target: target, rel: rel, itemProp: itemProp, onClick: onClick, className: className, title: title, role: role }, children));
    }
};
export { MultiLink };
//# sourceMappingURL=MultiLink.js.map